<template>
  <div class="phrases-modal">
    <tabs
      v-model="activeTab"
      :tabs="tabTitles"
    >
      <div key="Фразы" class="phrases-modal__tab">
        <template v-if="data">
          <section>
            <a-row :gutter="24">
              <a-col span="16">
                <edit-form-field :field="{ label: 'Категория' }" noHint>
                  <a-input v-model="data.name" size="large" @change="nameValidation" />
                </edit-form-field>

                <a
                  class="phrases-modal__link"
                  :href="exportUrl"
                  :download="exportFilename"
                  @click="exportPhrases(phrases)"
                >
                  <a-icon type="export" />
                  Экспорт всех фраз
                </a>

                <label class="phrases-modal__link">
                  <a-icon type="import" />
                  Импорт всех фраз

                  <input type="file" @change="importPhrases" />
                </label>

                <div style="margin-top: 20px">
                  <a-checkbox
                    :defaultChecked="Boolean(data.seasonal)"
                    class="edit-form-checkbox checkbox-wrap"
                    @change="checkboxChanged('seasonal', $event)"
                  >
                    <h3>Сезонный товар/услуга</h3>
                  </a-checkbox>
                </div>
              </a-col>

              <a-col span="8">
                <edit-form-field :field="{ label: 'Код ИПЦ' }" noHint>
                  <a-auto-complete
                    v-model="data.ipc"
                    :data-source="ipcList"
                    size="large"
                    style="width: 100%"
                    mode="default"
                    showSearch
                    :disabled="!Boolean(data.ipcEnabled)"
                    @search="(search) => (search_catalog(search, 'ipc'))"
                    />
<!--                  <a-select-->
<!--                    v-model="data.ipc"-->
<!--                    :options="ipcList"-->
<!--                    size="large"-->
<!--                    placeholder="Поиск"-->
<!--                    style="width: 100%"-->
<!--                    mode="default"-->
<!--                    showSearch-->
<!--                    :disabled="!Boolean(data.ipcEnabled)"-->
<!--                    @search="(search) => (ipcSelectSearch = search)"-->
<!--                  />-->
                  <template #beforeTitle>
                    <a-checkbox
                      :defaultChecked="Boolean(data.ipcEnabled)"
                      @change="checkboxChanged('ipcEnabled', $event)"
                    />
                  </template>
                </edit-form-field>

                <edit-form-field :field="{ label: 'Код КИПЦ' }" noHint>
                  <a-auto-complete
                    v-model="data.kipc"
                    :data-source="kipcList"
                    size="large"
                    style="width: 100%"
                    mode="default"
                    showSearch
                    :disabled="!Boolean(data.kipcEnabled)"
                    @search="(search) => (search_catalog(search, 'kipc'))"
                    />
<!--                  <a-select-->
<!--                    v-model="data.kipc"-->
<!--                    :options="kipcList"-->
<!--                    size="large"-->
<!--                    placeholder="Поиск"-->
<!--                    style="width: 100%"-->
<!--                    mode="default"-->
<!--                    showSearch-->
<!--                    :disabled="!Boolean(data.kipcEnabled)"-->
<!--                    @search="(search) => (kipcSelectSearch = search)"-->
<!--                  />-->
                  <template #beforeTitle>
                    <a-checkbox
                      :defaultChecked="Boolean(data.kipcEnabled)"
                      @change="checkboxChanged('kipcEnabled', $event)"
                    />
                  </template>
                </edit-form-field>


                <edit-form-field :field="{ label: 'Код ОКПД2' }" noHint>
                  <a-auto-complete
                    v-model="data.okpd2"
                    :data-source="okpdList"
                    size="large"
                    style="width: 100%"
                    mode="default"
                    showSearch
                    :disabled="!Boolean(data.okpd2Enabled)"
                    @search="(search) => (search_catalog(search, 'okpd'))"
                    />
<!--                  <a-select-->
<!--                    v-model="data.okpd2"-->
<!--                    :options="okpdList"-->
<!--                    size="large"-->
<!--                    placeholder="Поиск"-->
<!--                    style="width: 100%"-->
<!--                    mode="default"-->
<!--                    showSearch-->
<!--                    :disabled="!Boolean(data.okpd2Enabled)"-->
<!--                    @search="(search) => (search_catalog(search, 'okpd'))"-->
<!--                  />-->
                  <template #beforeTitle>
                    <a-checkbox
                      :defaultChecked="Boolean(data.okpd2Enabled)"
                      @change="checkboxChanged('okpd2Enabled', $event)"
                    />
                  </template>
                </edit-form-field>
              </a-col>
            </a-row>
          </section>

          <section>
            <edit-form-field :field="{ label: 'Требуемая упаковка. Объем' }" noHint>
              <a-input v-model="data.scale" size="large" type="number"/>
            </edit-form-field>
            <a-row :gutter="24" style="padding-top: 20px">
              <a-col span="12">
                <edit-form-field :field="{ label: 'Поиск единиц измерения' }" noHint>
                  <a-select
                    v-model="unitSelectValue"
                    :options="unitsList"
                    size="large"
                    placeholder="Поиск"
                    style="width: 100%"
                    mode="default"
                    labelInValue
                    showSearch
                    :filterOption="false"
                    :disabled="Boolean(data.units.length)"
                    @search="(search) => (unitSelectSearch = search)"
                    @select="addUnit"
                  />
                </edit-form-field>
              </a-col>

              <a-col span="12">
                <edit-form-field :field="{ label: 'Присвоенная единица измерения' }" noHint>
                  <base-tags
                    class="phrases-modal__tags phrases-modal__tags--dark"
                    :list="data.units"
                    :ellipsis="false"
                    showDelete
                    @deleteTag="deleteUnit"
                  />
                </edit-form-field>
              </a-col>
            </a-row>
          </section>

          <div class="phrases-modal__phrases">
            <section v-for="phrase of phrases" :key="phrase.main">
              <a-row :gutter="24">
                <a-col span="6">
                  <edit-form-field :field="{ label: 'Основная фраза' }" noHint>
                    <a-input
                      v-model="phrase.main" size="large" @blur="phrases=phrases"
                      @pressEnter="phrases=phrases"
                    />
                  </edit-form-field>

                  <a
                    class="phrases-modal__link"
                    :href="exportUrl"
                    :download="exportFilename"
                    @click="exportPhrases(phrase)"
                  >
                    <a-icon type="export" />
                    Экспорт
                  </a>

                  <label class="phrases-modal__link">
                    <a-icon type="import" />
                    Импорт
                    <input type="file" @change="importPhrases($event, phrase)" />
                  </label>
                </a-col>

                <a-col span="18">
                  <edit-form-field :field="{ label: 'Исключения из фразы' }" noHint>
                    <base-tags
                      class="phrases-modal__tags"
                      :list="phrase.exceptions"
                      :ellipsis="false"
                      showDelete
                      @deleteTag="deletePhraseException(phrase, $event)"
                    >
                      <template #suffix>
                        <a-button
                          size="small"
                          type="primary"
                          @click="showNewExceptionPopover($event, phrase)"
                        >
                          +
                        </a-button>
                      </template>
                    </base-tags>
                  </edit-form-field>
                </a-col>
              </a-row>
            </section>
          </div>
        </template>
      </div>

      <div key="Инструкция" class="phrases-modal__tab">
        <template v-if="data">
          <section>
            <edit-form-text-editor v-model="data.instruction" />
          </section>
        </template>
      </div>

      <div key="Машинное обучение" class="phrases-modal__tab">
        <template v-if="data">
          <section>
            <div class="block-wrapper">
              <machine-learning-config v-model="data.machine_learning_config[0].data" :categoryName="data.name" />
            </div>
          </section>
        </template>
      </div>

      <div key="Математическая обработка" class="phrases-modal__tab">
        <template v-if="data">
          <section>
            <div class="block-wrapper">
              <math-processing-config v-model="data.math_config[0].data" />
            </div>
          </section>
        </template>
      </div>
    </tabs>

    <section class="phrases-modal__footer">
      <a-button
        class="phrases-modal__form-action" size="large" type="primary"
        @click="save"
      >
        <a-icon type="save" />
        Сохранить
      </a-button>

      <a-button
        class="phrases-modal__form-action" size="large" type="primary"
        @click="addPhrase"
      >
        <a-icon type="plus-circle" />
        Добавить фразу
      </a-button>

      <a-popconfirm
        okText="Удалить"
        cancelText="Отмена"
        title="Подтвердите удаление"
        @confirm="deleteEntity"
      >
        <a-button class="phrases-modal__form-action" size="large"> Удалить</a-button>
      </a-popconfirm>

      <a-button class="phrases-modal__form-action" size="large" @click="closeForm">
        Отмена
      </a-button>
    </section>

    <a-spin :spinning="!!loadingKeys" />

    <a-popover
      v-model="popoverVisible"
      trigger="click"
      :align="{
        target: popoverTarget,
      }"
      @visibleChange="popoverVisibilityChange"
    >
      <template #content>
        <a-input v-model="newException" />
      </template>
    </a-popover>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import axios from "axios";
import store from '@/store';
import { preparePayload, storage } from '@/helpers';
import GET_QUERY from '@/queries/get';
import META_QUERY from '@/queries/meta';
import TABLE_QUERY from '@/queries/table';
import UPDATE_MUTATION from '@/queries/mutations/update';
import CREATE_MUTATION from '@/queries/mutations/create';
import DELETE_MUTATION from '@/queries/mutations/delete';
import Tabs from '@/components/base/Tabs.vue';
import BaseTags from '@/components/base/BaseTags.vue';
import EditFormField from '@/components/edit-form/EditFormField.vue';
import EditFormTextEditor from '@/components/edit-form/fields/EditFormTextEditor.vue';
import MathProcessingConfig from '@/components/math-processing/MathProcessingConfig';
import MachineLearningConfig from '@/components/machine-learning/MachineLearningConfig';

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;
const esUrl = process.env.VUE_APP_ELASTIC_URL;

const tabs = Object.freeze({
  TAB_PHRASES: 'Фразы',
  TAB_INSTRUCTION: 'Инструкция',
  TAB_MACHINE_LEARNING: 'Машинное обучение',
  TAB_MATH_PROCESSING: 'Математическая обработка',
});



export default {
  name: 'PhrasesModal',

  components: {
    MachineLearningConfig,
    MathProcessingConfig,
    Tabs,
    BaseTags,
    EditFormField,
    EditFormTextEditor,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    visibleTabs: {
      type: Object,
      default: null,
    }
  },

  apollo: {
    meta: {
      ...META_QUERY,
      loadingKeys: 'loadingKeys',
      variables() {
        return {
          type: this.type,
        };
      },
      error(error, vm, key, type, { variables }) {
        this.emitError(`Ошибка получения meta-данных ${variables.type}. ${error.message};`);
      },
    },
    sourceData: {
      ...GET_QUERY,
      loadingKeys: 'loadingKeys',
      variables() {
        return {
          id: this.id,
          type: this.type,
        };
      },
      skip() {
        return this.isLocalDraft;
      },
      error(error) {
        this.emitError(
          `Ошибка получения данных сущности ${this.type}:${this.id}. ${error.message}`,
        );
      },
    },
    unitsListAll: {
      ...TABLE_QUERY,
      loadingKey: 'loadingQueries',
      debounce: 250,
      variables() {
        return {
          type: 'FNSBaseUnit',
          page: 0,
          pageSize: 999,
          filters: [],
          orders: [],
        };
      },
      update({ table }) {
        return table.documents;
      },
    },
  },

  data() {
    return {
      loadingKeys: 0,
      activeTab: null,
      tabTitles: [],
      tabs,
      exportUrl: '#',
      exportFilename: '#',
      modalBodyStyle: {
        height: '70vh',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: '8px',
        minWidth: '30rem',
        padding: '30px',
      },
      newException: '',
      popoverTarget: null,
      popoverVisible: false,
      data: null,
      ipc: null,
      ipcList: [],
      kipcList: [],
      okpdList: [],
      unitSelectValue: undefined,
      unitSelectSearch: '',
      ipcSelectSearch: '',
      kipcSelectSearch: '',
      okpdSelectSearch: '',
      catalogSelectSearch: {
        'ipc': '',
        'kipc': '',
        'okpd': ''
      }
    };
  },

  computed: {
    phrases: {
      get() {
        return this.parsePhrases(this.data.phrases);
      },
      set(phrases) {
        if (this.sourceData||this.isLocalDraft) this.data.phrases = this.getTextPhrases(phrases);
      },
    },
    isLocalDraft() {
      return this.id.startsWith('_temp');
    },
    units: {
      get() {
        return (this.data.units || []).map((o) => ({
          key: o.value,
          label: o.title,
        }));
      },
      set(value) {
        this.$set(
          this.data,
          'units',
          value.map((option) => ({
            value: option.key,
            title: option.label,
          })),
        );
      },
    },
    unitsList() {
      return (
        this.unitsListAll
          ?.map((option) => ({
            title: option.data.title,
            value: `FNSBaseUnit:${option.id}`,
          }))
          .filter((option) => !this.units.find((unit) => unit.key === option.value))
          .filter((option) =>
            option.title.toLowerCase().includes(this.unitSelectSearch.toLowerCase()),
          ) || []
      );
    }
  },

  watch: {
    sourceData: {
      handler() {
        this.initData();
      },
    }
  },
  created() {
    if (this.visibleTabs){
      const conf_tabs = Object.keys(this.visibleTabs).filter((key)=>this.visibleTabs[key])
      conf_tabs.forEach((vis_tab)=> {
        this.tabTitles.push(this.tabs[vis_tab])
      })
    }
    else {
      this.tabTitles = Object.values(this.tabs)
    }
    this.activeTab = this.tabTitles[0]
    if (this.isLocalDraft) this.initData();
  },

  methods: {
    nameValidation(e){
      this.data.name = e.target.value.replace('/', '-').replace('_', '-')
    },
    get_catalogs() {
      const query = {
        "size": 100,
        "from": 0,
      }
      const dataRequest = axios.CancelToken.source();
      this.ipcList = []
      this.kipcList = []
      this.okpdList = []

      this.axios
        .post(`${esUrl}/ipc/_search?pretty`, query, {
          cancelToken: dataRequest.token,
        })
        .then(({data}) => {
          // this.ipcList =
          //   data.hits.hits?.map((option) => ({
          //     title: option._source['Код ИПЦ'],
          //     value: option._source['Код ИПЦ'],
          //   }))
          //     .filter((option) =>
          //       option.title.includes(this.catalogSelectSearch.ipc),
          //     )
          //   || []
          this.ipcList =
            data.hits.hits?.map((option) => option._source['Код ИПЦ'])
              .filter((option) =>
                option.includes(this.catalogSelectSearch.ipc),
              )
            || []
        })
        .catch((error) => {
          throw error
        })
      this.axios
        .post(`${esUrl}/kipc/_search?pretty`, query, {
          cancelToken: dataRequest.token,
        })
        .then(({data}) => {
          this.kipcList =
            data.hits.hits?.map((option) => option._source['Код класси-фикаци-онный'])
              .filter((option) =>
                option?.split('.').length === 4,
              )
              .filter((option) =>
                option.includes(this.data?.kipc),
              ) || []
        })
        .catch((error) => {
          throw error
        })
      this.axios
        .post(`${esUrl}/nsi_okpd2/_search?pretty`, query, {
          cancelToken: dataRequest.token,
        })
        .then(({data}) => {
          this.okpdList =
            data.hits.hits?.map((option) => option._source['Код'])
              .filter((option) =>
                option?.split('.').length === 4,
              )
              .filter((option) =>
                option.includes(this.data?.okpd2),
              )
            || []
        })
        .catch((error) => {
          throw error
        })
    },
    initData() {
      this.get_catalogs()
      const data = this.isLocalDraft ? {} : this.sourceData?.document.data;
      const units = data.units || [];
      const machine_learning_config = data.machine_learning_config || [
        {
          type: 'FNSMachineLearningConfig',
          data: {},
        },
      ];
      machine_learning_config[0].data.category = data.name;

      let math_config = data.math_config || [
        {
          type: 'FNSMathConfig',
          data: {},
        },
      ];

      if (math_config.data) {
        math_config = [math_config];
      }

      this.data = data && {
        ...data,
        units,
        math_config,
        machine_learning_config,
        ...(store.mutate.getFormDraft(this.type, this.id)?.data || {}),
      };
      this.prevData = data && {
        ...data,
        units,
        math_config,
        machine_learning_config,
        ...(store.mutate.getFormDraft(this.type, this.id)?.data || {}),
      };
    },
    deleteUnit(deletedUnit) {
      this.data.units = this.data.units.filter((unit) => unit.value !== deletedUnit);
    },
    deletePhraseException(phrase, deletedItem) {
      phrase.exceptions = phrase.exceptions.filter((exception) => exception.value !== deletedItem);
      this.phrases = this.phrases.slice();
    },
    addPhrase() {
      this.phrases = [...this.phrases, { main: ' ', exceptions: [] }];
      // @TODO
      this.$nextTick(() => {
        const tabs1 = this.$el.querySelector('.tabs__content');
        tabs1.scrollTop = tabs1.scrollHeight;
      });
    },
    deleteEntity() {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            type: this.type,
            id: this.id,
          },
        })
        .then(() => {
          this.$notification.success({
            message: `Категория удалена..`,
          })

          axios
            .post(`${apiUrl}/report/delete`, {
              type: this.type,
              entityId: this.id,
              prevData: preparePayload(this.prevData, this.meta.components[this.type].fields),
            }, {
              headers: {
                'finch-auth': `Bearer ${storage.get('authToken')}`,
                'fio': encodeURIComponent(store.state.userFio),
                'region': encodeURIComponent(store.state.regionName)
              }
            })
            .catch((err) => {
              this.$notification.error({
                message: `Не удалось сохранить запись в логи. Обратитесь к администратору.`,
              });
              throw err
            })
          this.closeForm();

        })
        .catch((err) => {
          console.log(err);
          this.$notification.error({
            message: `Произошла ошибка. Обратитесь к администратору.`,
          });
        });
    },
    async save() {
      this.phrases = this.parsePhrases(this.data.phrases)
        .filter(({main})=>main!=='')
      const response = await this.$apollo.mutate({
        mutation: this.isLocalDraft ? CREATE_MUTATION : UPDATE_MUTATION,
        variables: {
          type: this.type,
          id: this.isLocalDraft ? undefined : this.id,
          data: preparePayload(this.data, this.meta.components[this.type].fields),
        },
      });
      const result = response.data.update || response.data.create;
      if (!result.errors.length) {
        store.mutate.deleteFormDraft(this.type, this.id);
        this.$notification.success({
          message: 'Данные сохранены',
        });
        await axios
          .post(`${apiUrl}/report/${this.isLocalDraft ? 'create' : 'update'}`, {
            type: this.type,
            entityId: this.isLocalDraft ? '' : this.id,
            data: preparePayload(this.data, this.meta.components[this.type].fields),
            prevData: preparePayload(this.prevData, this.meta.components[this.type].fields),
          }, {
            headers: {
              'finch-auth': `Bearer ${storage.get('authToken')}`,
              'fio': encodeURIComponent(store.state.userFio),
              'region': encodeURIComponent(store.state.regionName)
            }
          })
          .catch((err) => {
            this.$notification.error({
              message: `Не удалось сохранить запись в логи. Обратитесь к администратору.`,
            });
            throw err
          })
      } else {
        this.$notification.error({
          message: 'Не удалось сохранить данные',
        });
      }

      const createdId = response.data.create?.document?.id;
      if (createdId) {
        this.$emit('editingEntityIdChanged', createdId);
      }

      return response;
    },
    getTextPhrases(phrases) {
      return phrases
        .filter((el)=>el.main!=="")
        .map(
          (phrase) =>
            `${phrase.main} ${phrase.exceptions.length ? '-' : ''}${phrase.exceptions
              .map((item) => item.value)
              .join(' -')}`,
        )
        .join('\n');
    },
    parsePhrases(phrase) {
      return phrase
        ? phrase
          .replace(/\n+/g, '\n')
          .split(/\n/g)
          .map((phrases) => {
            phrases = phrases.replace(/\s+/g, ' ').trim().split(/\s-/g) || [''];

            const main = phrases.shift();
            const exceptions = [...new Set(phrases)].map((title) => ({
              value: title,
              title,
            }));
            return { main, exceptions };
          })
        : [{ main: '', exceptions: [] }];
    },
    exportPhrases(phrases) {
      const isArray = Array.isArray(phrases);
      const phraseName = isArray ? '' : `-${phrases.main}`;
      phrases = Array.isArray(phrases) ? phrases : [phrases];
      const text = encodeURIComponent(this.getTextPhrases(phrases));
      this.exportUrl = `data:text/plain;charset=utf-8,${text}`;
      this.exportFilename = `export-${this.data.name}-phrases${phraseName}-${moment().format(
        'DDMMYYHHmmss',
      )}.txt`;
    },
    async importPhrases(evt, phrase) {
      const comp = this;
      const inputFile = evt.target.files[0];
      this.loadingKeys++;

      let result = await new Response(inputFile).text();
      result = this.parsePhrases(result);

      if (phrase) {
        comp.phrases = this.phrases.map((p) => (p.main === phrase.main ? result[0] : p));
      } else {
        comp.phrases = result;
      }

      this.loadingKeys--;
    },
    closeForm() {
      this.$emit('close');
    },
    showNewExceptionPopover(event, phrase) {
      this.popoverTarget = event.target;
      this.popoverPhrase = phrase;
      this.popoverVisible = true;
    },
    popoverVisibilityChange(visible) {
      if (!visible) {
        this.popoverPhrase.exceptions.push({
          value: this.newException,
          title: this.newException,
        });

        this.phrases = this.phrases.slice();
        this.newException = '';
      }
    },
    checkboxChanged(field, { target }) {
      this.$set(this.data, field, target.checked);
    },
    search_catalog(value, type){
      this.catalogSelectSearch[type] = value;
      this.get_catalogs()
    },
    addUnit(value) {
      this.units = [...this.units, value];
      this.unitSelectValue = undefined;
    },
  },
};
</script>

<style lang="scss">
.phrases-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  .tabs {
    &__switch-list {
      background: #ECF1F8;
    }

    &__pane {
      padding-top: 20px;
    }
  }

  .entity-field__head {
    .ant-checkbox {
      margin-right: 10px;
    }
  }

  .ant-select-selection {
    border-radius: 2px;

    .ant-select-arrow {
      display: none;
    }
  }

  .ant-spin {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    &.ant-spin-spinning {
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.33);
    }
  }

  &__link {
    position: relative;
    display: inline-block;
    margin: 10px 20px 0 0;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    overflow: hidden;

    .anticon {
      margin-right: 4px;
      font-size: 16px;
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
    }
  }

  label.phrases-modal__link {
    @include link();
  }

  .tabs__switch-list-wrap {
    padding: 30px 30px 20px;
  }

  section {
    padding: 20px 30px;

    &:nth-child(even) {
      background: #ecf1f8;
    }
  }

  &__tab > section:first-child {
    padding-top: 0;
  }

  &__tags {
    .tags__item {
      font-size: 14px;
      font-weight: 500;
    }

    &--dark .tags__item,
    &--dark .anticon {
      background-color: #366dbb;
      color: #fff;
    }

    .ant-btn {
      margin-top: 10px;
      vertical-align: middle;
    }
  }

  .tags {
    max-width: none;
  }

  .entity-field {
    margin-bottom: 0;

    & + .entity-field {
      margin-top: 10px;
    }
  }

  h3 {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 6px;
  }

  &__tab {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .tabs__content {
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    min-height: 0;
    @include scrollbars();
    overflow-y: scroll;
  }

  .tabs {
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    min-height: 0;
  }

  &__footer {
    border-top: 2px solid #e1eaf5;
  }

  &__form-action {
    width: 160px;
    margin-right: 10px;
    border: none !important;

    .anticon {
      font-size: 15px;
      vertical-align: middle;
    }
  }
}
</style>
